/**
 *  Video plugin or system module implementation.
 *  Same interface with audio provider from embedded magcore.
 */

'use strict';

var gettextWrapper = require('mag-gettext'),
    Provider = require('./provider'),

    provider = {};

function getLauncherProvider ( providerConfig, ready ) {
    var gettext = gettextWrapper.gettext,
        query = {
            limit: 10,
            sortby: 'added'
        },
        api = providerConfig.api,
        path = providerConfig.path + 'img/' + screen.height + '/';

    Provider.prototype.getAlbums(query, function ( error, data ) {
        var config, img, icon;

        if ( !error && data.length ) {
            config = {
                provider: provider,
                data: data.map(function ( album ) {
                    var genres = album.genres.map(function ( genre ) {
                        return genre;
                    });

                    if ( album.cover ) {
                        img = {
                            normal: core.backend.host + album.cover,
                            active: core.backend.host + album.cover
                        };
                    } else {
                        icon = {
                            normal: path + 'audio.png',
                            active: path + 'audio-focus.png'
                        };
                    }

                    return {
                        id: album.id,
                        layout: api.layouts.static,
                        geometry: api.geometry.square,
                        data: {
                            name: album.artist.name,
                            icon: icon,
                            image: img,
                            description: album.name,
                            meta: [album.year.name, genres.join(', ')],
                            album: album
                        },
                        onClick: function () {
                            core.intent({
                                action: 'audioClub',
                                mime: 'info',
                                data: this.data.album
                            });
                        }
                    };
                })
            };

            config.data.push(
                {
                    layout: api.layouts.static,
                    geometry: api.geometry.square,
                    data: {
                        name: gettext('See more'),
                        icon: {
                            normal: path + 'see-more.png',
                            active: path + 'see-more-focus.png'
                        }
                    },
                    onClick: function () {
                        core.intent({
                            action: 'audioClub',
                            mime: ''
                        });
                    }
                }
            );

            ready(false, config);
        } else {
            ready(true, {
                provider: provider,
                data: []
            });
        }
    });
}

provider.search = function ( cfg, callback ) {
    callback(true);
};


module.exports = {
    onAppInit: function ( config, callback ) {
        callback(null, new Provider());
    },
    onContentBoardInit: function ( config, done ) {
        gettextWrapper.load({
            name: core.environment.language,
            path: config.path + 'lang'
        }, function () {
            getLauncherProvider(config, done);
        });
    }
};
